import { doc, updateDoc, arrayUnion } from "firebase/firestore";
import { getFirestore } from "./firebase";

const useFirestoreUpdate = (collection, docId) => {
  const db = getFirestore();

  // Function to format the date
  const formatDate = (timestamp) => {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(timestamp);
  };

  const updateData = async (data) => {
    const inscriptosRef = doc(db, collection, docId);

    // Format the date before sending
    const formattedDate = formatDate(Date.now());

    // Firestore no permite valores `undefined` en documentos
    const sanitized = Object.fromEntries(
      Object.entries({ ...data, createdAt: formattedDate }).filter(([, v]) => v !== undefined)
    );

    const newEntry = sanitized;

    // Update Firestore document
    await updateDoc(inscriptosRef, {
      datos: arrayUnion(newEntry),
    });
  };

  return { updateData };
};

export default useFirestoreUpdate;
